import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import iconMenu from '../images/burger.svg'
import { slide as Menu } from 'react-burger-menu'
import { Link as ScrollLink } from 'react-scroll'

import './index.scss'

const TemplateWrapper = ({
  children
}) => (
    <div id="top">
      {children()}
    </div>
  )

TemplateWrapper.propTypes = {
  children: PropTypes.any,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js